import Image from "next/image";
import { Button, Container, Hidden } from "@mui/material";
// import Button from "@mui/material";
import { styled } from "@mui/system";
import heroImgNew from "../../../assets/imgs/main-website/BecomeATeacher-Hero-New.png";
import styles from "./BecomeTeacherBanner.module.css";
import { getUserData } from "../../../hooks/HelperFunctions";
import { apiRequest } from "../../../utils/axiosInstance";
import { useState } from "react";
import SimpleBackdrop from "../../Backdrop/SimpleBackdrop";

const BecomeTeacherBanner = (props) => {
  const { redirectToForm, setOpenSignUpModel,getStartedHandler } = props;

  

  return (
    <div className={styles.heroContainer}>
      
      <div className={styles.heroContainerbody}>
        <div className={styles.heroInfo}>
          <p>Become a teacher</p>
          <h3>Share your knowledge with the Ummah.</h3>
          <p>
            Plan, Create and Launch pre-recorded or live courses you are
            passionate about teaching the global Muslim learners
          </p>
          <StyledButton variant="contained" onClick={(e) => getStartedHandler()}>
            Get Started
          </StyledButton>
        </div>
        
      </div>
      <div className={styles.HeroImage}>
          <Image src={heroImgNew} />
        </div>
    </div>
  );
};

export default BecomeTeacherBanner;

const StyledContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "10px !important",
  padding: "14px 46px !important",
  background: "#004FE0 !important",
  boxShadow: "none !important",
  color: "#fff !important",
  borderRadius: "10px !important",
  "&:hover": {
    background: "#004FE0 !important",
    boxShadow: "none !important",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: "26px !important",
  },
}));
